import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import Konva from 'konva';
import { Group, Image } from 'react-konva';
import { setIrrandiance } from 'store/slices/IrradianceSlice';
import { useKonvaImageDimensions } from 'contexts/ToolDimensionsAndScaleContext';
import { konvaImageIds } from 'components/tool/utils/konvaUtil';

interface Props {
	layerRef: React.MutableRefObject<Konva.Layer | null>
}
export default function Irradiance({ layerRef }: Props) {
	const { imgHeight, imgWidth, imagerySource } = useSelector((state: RootState) => state.roofData.data);
	const { selectedMonth, irradianceImages, showProgress } = useSelector((state: RootState) => state.Irradiance.data);
	const image = useMemo(() => new window.Image(imgWidth, imgHeight), [imgWidth, imgHeight]);
	const [imageLoaded, setImageLoaded] = useState<boolean>(false);
	const irradiance = irradianceImages[imagerySource as keyof typeof irradianceImages];
	const dispatch = useDispatch();
	const imgDims = useKonvaImageDimensions();

	useEffect(() => {
		function handleImageLoad() {
			layerRef?.current?.batchDraw();
			setImageLoaded(true);
		}

		function handleImageError() {
			dispatch(setIrrandiance({ showIrradiance: false }));
			console.log('irradiance error');
		}

		if (irradiance?.length && layerRef?.current && !showProgress) {
			const base64 = irradiance[selectedMonth];
			image.src = `data:image/png;base64,${base64}`;
			image.onload = handleImageLoad;
			image.onerror = handleImageError;
		}
		return () => {
			image.onload = null;
			image.onerror = null;
			image.src = '';
		};
	}, [selectedMonth, irradiance, layerRef, dispatch, image, showProgress]);

	return (
		<>
			{imageLoaded && <Group id={konvaImageIds.irradianceImageGroup}>
				<Image
					image={image}
					preventDefault={false}
					height={imgDims.height}
					width={imgDims.width}
				/>
			</Group>}
		</>
	);
}
